import React from 'react';
import { Link } from 'react-router-dom';
import './mobile.css';

function Tile({ to, icon, title }) {
  return (
    <Link className="m-homeTile" to={to}>
      <div className="m-homeTileIcon" aria-hidden="true">{icon}</div>
      <div className="m-homeTileTitle">{title}</div>
    </Link>
  );
}

export default function MobileHomePage() {
  return (
    <div className="m-home">
      <div className="m-homeHero">
        <div className="m-homeBrandRow">
          <div className="m-homeLogo" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 2l8 4v6c0 5.25-3.2 9.9-8 10-4.8-.1-8-4.75-8-10V6l8-4z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <path
                d="M9.25 12.5c.75-1.3 2-2 3.75-2 1.75 0 2.9.75 2.9 2.1 0 1.05-.65 1.6-1.7 2.15-.8.42-1.55.8-1.7 1.8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path d="M12 18.9h.01" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
            </svg>
          </div>
          <div className="m-homeBrand">众邦劳务紫铜项目部</div>
        </div>

        <div className="m-homeTitle">安全管理平台</div>
        <div className="m-homeSub">赋能安全管理，守护生产未来</div>
      </div>    

      <div className="m-homeTiles">
        <Tile to="/m/training" icon="培" title="教育培训" />
        <Tile to="/m/hazards" icon="隐" title="隐患排查" />
        <Tile to="/m/checkin" icon="卡" title="日常签到" />
        <Tile to="/m/me" icon="我" title="个人信息" />
      </div>

      <div className="m-homeDivider" />

      <div className="m-homeOverview">
        <div className="m-homeOverviewTitle">实时安全总览</div>
        <div className="m-homeKpis">
          <div className="m-homeKpi">
            <div className="m-homeKpiLabel">今日隐患</div>
            <div className="m-homeKpiValue">—</div>
          </div>
          <div className="m-homeKpi">
            <div className="m-homeKpiLabel">本月培训完成率</div>
            <div className="m-homeKpiValue">—</div>
          </div>
          <div className="m-homeKpi">
            <div className="m-homeKpiLabel">巡检覆盖率</div>
            <div className="m-homeKpiValue">—</div>
          </div>
        </div>

        <div className="m-homeProgress">
          <div className="m-homeProgressHead">
            <div className="m-homeProgressLabel">风险评估</div>
            <div className="m-homeProgressHint">覆盖隐患</div>
          </div>
          <div className="m-homeProgressBar" aria-hidden="true">
            <div className="m-homeProgressFill" style={{ width: '35%' }} />
          </div>
          <div className="m-homeProgressFoot">
            <div>隐患总数</div>
            <div>强度赋能</div>
          </div>
        </div>

        <div className="m-homeBigNums">
          <div className="m-homeBigNum">
            <div className="m-homeBigValue">35</div>
            <div className="m-homeBigLabel">部门</div>
          </div>
          <div className="m-homeBigNum" style={{ textAlign: 'right' }}>
            <div className="m-homeBigValue">98.65</div>
            <div className="m-homeBigLabel">绩效考核</div>
          </div>
        </div>

        <div className="m-homeFooter">© 2026 企业安全。All rights reserved.</div>
      </div>

      <div className="m-card m-cardPad" style={{ marginTop: 10 }}>
        <div className="m-muted">提示：部分功能需要对应权限，若提示无权限请联系管理员开通。</div>
      </div>
    </div>
  );
}
